import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { AttachmentState } from 'owa-attachment-well-data';
import { lazyGetTypeOfAttachment } from 'owa-addins-common-utils';
import { TypeOfAttachment } from 'owa-addins-apis-types';
import ItemAttachment from 'owa-service/lib/contract/ItemAttachment';
import { assertNever } from 'owa-assert';

const ITEM_CLASS_NOTE = 'IPM.Note';
export interface AttachmentContent {
    format: AttachmentContentFormat;
    content: string;
}

export enum AttachmentContentFormat {
    Base64 = 'base64',
    Eml = 'eml',
    Url = 'url',
    Ical = 'iCalendar',
}

export default async function getAttachmentContentHelper(
    attachmentState: AttachmentState,
    attachmentId: string
): Promise<AttachmentContent> {
    let attachmentDownloadURL = null;
    var base64Content = null;
    let response: Response = null;
    let data = null;
    let attachmentContent: AttachmentContent = {
        content: '',
        format: AttachmentContentFormat.Base64,
    };

    const attachmentModel = getAttachment(attachmentState.attachmentId);
    const attachmentType = await lazyGetTypeOfAttachment.importAndExecute(
        attachmentModel.model.__type
    );

    if (attachmentType === TypeOfAttachment.Item) {
        attachmentDownloadURL = attachmentModel.download.url;
        response = await fetch(attachmentDownloadURL);
        data = await response.text();
        // EmbeddedItemClass parameter is not being populated for item attachments in compose mode, hence the "or" condition.
        const embeddedItemClass =
            (attachmentModel.model as ItemAttachment).EmbeddedItemClass || ITEM_CLASS_NOTE;
        if (embeddedItemClass === 'IPM.Note') {
            attachmentContent.format = AttachmentContentFormat.Eml;
        } else {
            attachmentContent.format = AttachmentContentFormat.Ical;
        }
        attachmentContent.content = data;
    } else if (attachmentType === TypeOfAttachment.Cloud) {
        attachmentDownloadURL = attachmentModel.download.url;
        let searchParams = new URLSearchParams(attachmentDownloadURL);
        let content = searchParams.get('location');
        var urlDecodedContent: string = decodeURIComponent(content);
        attachmentContent.format = AttachmentContentFormat.Url;
        attachmentContent.content = urlDecodedContent;
    } else if (attachmentType === TypeOfAttachment.File) {
        attachmentDownloadURL = attachmentModel.download.url + '&asDataUri=true';
        response = await fetch(attachmentDownloadURL);
        data = await response.text();
        // This is to strip off the type from base64 string
        base64Content = data.substr(data.indexOf(',') + 1);
        base64Content = removeWhiteSpace(base64Content);
        attachmentContent.format = AttachmentContentFormat.Base64;
        attachmentContent.content = base64Content;
    } else {
        assertNever(attachmentType as never);
    }

    return attachmentContent;
}

/**
 * Removes all white space from the provided text
 * @param text Text to remove string from
 */
export function removeWhiteSpace(text: string): string {
    return text ? text.replace(/\s+/g, '') : text;
}
